App.controller('RegenerateLinkCtrl', [
    '$scope',
    '$state',
    '$localStorage',
    '$stateParams',
    'toastr',
    'apiService',
    '$loading',
    'ngDialog',
    '$window',

    function (
        $scope,
        $state,
        $localStorage,
        $stateParams,
        toastr,
        apiService,
        $loading,
        ngDialog,
        $window
    ) {
        var token = $localStorage['token'];
        if (token) {
            $state.go('splash');
        } else {
            var viewModel = this;
            viewModel.check1 = false;
            viewModel.check2 = false;
            viewModel.message = '';
            viewModel.regenerateLink = regenerateLink;
            viewModel.openPrnJobPopup = openPrnJobPopup;
            viewModel.closePopup = closePopup;
            viewModel.email = '';
            viewModel.redirectURL = '';

            // =============to regenerate link=============
            function regenerateLink() {
                console.log('Email entered: ', viewModel.email);
                $loading.start('regenerateLink');
                apiService
                    .regenerateLink(viewModel.email)
                    .then(function (response) {
                        $loading.finish('regenerateLink');
                        viewModel.redirectURL = '';
                        viewModel.openPrnJobPopup('Successfully resent verification. Please check your email.');
                        $scope.$apply()
                    })
                    .catch(function (err) {
                        $loading.finish('regenerateLink');
                        if (err instanceof Error && err.name === 'UserNotFoundError') {
                            viewModel.redirectURL = 'https://support.praoshealth.com/hc/en-us/requests/new';
                            viewModel.openPrnJobPopup('We are unable to locate the account for this email address. Please contact your organization for the email address associated with your account or to request a new account.');
                        }
                        else if (err instanceof Error && err.name === 'AccountAlreadyVerifiedError') {
                            viewModel.redirectURL = window.location.protocol + "//" + window.location.host;
                            viewModel.openPrnJobPopup('Your account is active! Click on the forgot password link on your login screen if you forgot your password.');
                        } else {
                            viewModel.redirectURL = '';
                            viewModel.openPrnJobPopup(err.message);
                        }
                        
                        $scope.$apply()
                    })
            }

            // =============to open popup=============
            function openPrnJobPopup(message) {
                viewModel.message = message;
                dialogId = ngDialog.open({
                    template: 'regenerateInfoPopup',
                    className: 'ngdialog-theme-default documentation-dialog prn-dialog',
                    closeByNavigation: true,
                    showClose: false,
                    scope: $scope,
                    closeByDocument: false,
                    closeByEscape: false,
                });
            }

            // =============to close popup=============
            function closePopup() {
                ngDialog.closeAll();
                if (viewModel.redirectURL && viewModel.redirectURL != '') {
                    $window.location.href = viewModel.redirectURL;
                } else {
                    $window.location.reload();
                }
            }
        }
    },
]);
